'use strict';

DoohApps
.directive('autoFillSync', ['$timeout', function ($timeout) {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, model) {
            var origVal = elem.val();
            $timeout(function () {
                var newVal = elem.val();
                if (origVal !== newVal) {
                    model.$setViewValue(newVal);
                }
            }, 500);
        }
    };
}]);